/**
 * Directive responsible for the color picker used for color searches.
 * Based on the diy.combobox
 */
diy.angular.registerDirective('diyfmcolorsfilter', ['diyl10n', 'diyfmsectionsdata',
function(diyl10n, diyfmsectionsdata) {
    var $ = jQuery
        COLOR_ALL = 'all',
        COLOR_BW = 'black_and_white';

    return {
        template: '',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            var $elem = $(elem), i;

            scope.colors = [{
                id: 'all',
                value: COLOR_ALL
            }, /* DISABLED - support not implemented by CMS {
                id: 'blackAndWhite',
                value: COLOR_BW
            },*/ {
                id: 'red',
                value: 'ff0000'
            }, {
                id: 'orange',
                value: 'ffa500'
            }, {
                id: 'yellow',
                value: 'ffff00'
            }, {
                id: 'green',
                value: '008000'
            }, {
                id: 'blue',
                value: '0000ff'
            }, {
                id: 'purple',
                value: 'ee82ee'
            }, {
                id: 'white',
                value: 'ffffff'
            }, {
                id: 'grey',
                value: '808080'
            }, {
                id: 'black',
                value: '000000'
            }];
            for (i = 0; i < scope.colors.length; i++) {
                scope.colors[i].label = diyl10n('filemanager.colorsearch.' + scope.colors[i].id);
            }
            scope.selectedColor = null;

            var colorRenderer = function(elem, item) {
                var css;

                // reset special classes //
                elem.removeClass([
                    'diye-color-all',
                    'diye-color-bw',
                    'diye-color-white'
                ].join(' '));

                if (!item || !item.rawValue) {
                    elem.html('<span class="diye-color-empty-label">' + diyl10n('filemanager.colorsearch.placeholder') + '</span>');
                    return;
                }

                elem.html('<span class="diye-color-box"></span>' + item.label);
                if (item.rawValue === COLOR_ALL){
                    elem.addClass('diye-color-all');
                } else if (item.rawValue === COLOR_BW) {
                    elem.addClass('diye-color-bw');
                } else {
                    css = {
                        backgroundColor: '#' + item.rawValue
                    }
                    // special rule just for White //
                    if (item.id === 'white') {
                        elem.addClass('diye-color-white');
                    }
                    elem.find('.diye-color-box').css(css);
                }
            };

            $elem.diy_combobox({

                data: scope.colors,
                emptyText: '',
                menuCssClass: 'diye-fm-colorsfilter',
                select: function(e, ui) {
                    scope.$apply(function() {
                        scope.selectedColor = ui.rawValue;
                    });
                    return false;
                },
                renderPreview: colorRenderer,
                renderItem: colorRenderer
            });

            // init color selector //
            scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection, oldSubsection) {
                // do a reset when changing to a new section //
                if (newSubsection) {
                    scope.selectedColor = null;
                    newSubsection.setColorSearch(null);
                    $elem.diy_combobox('option', 'rawValue', null);
                }
            });
            scope.$watch('selectedColor' , function (newColor, oldColor) {
                var subsection = diyfmsectionsdata.getCurrentSubsection();
                if (subsection) {
                    if (newColor && newColor !== COLOR_ALL) {
                        subsection.setColorSearch(newColor);
                    } else {
                        subsection.setColorSearch(null);
                    }
                }
            });

            //TODO: watch for destroy and unbind all event handlers - if any!
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmcolorsfilter.js
 ** module id = 982
 ** module chunks = 0
 **/